import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esProperties from './locales/es/properties.json';
import esDashboard from './locales/es/dashboard.json';
import esCatalog from './locales/es/catalog.json';
import esCompanies from './locales/es/companies.json';
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enProperties from './locales/en/properties.json';
import enDashboard from './locales/en/dashboard.json';
import enCatalog from './locales/en/catalog.json';
import enCompanies from './locales/en/companies.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        properties: esProperties,
        dashboard: esDashboard,
        catalog: esCatalog,
        companies: esCompanies,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        properties: enProperties,
        dashboard: enDashboard,
        catalog: enCatalog,
        companies: enCompanies,
      },
    },
    fallbackLng: 'es',
    defaultNS: 'common',
    ns: ['common', 'auth', 'properties', 'dashboard', 'catalog', 'companies'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },
  });

export default i18n;
